export default {
    "name": "UpdateGroup",
    "kind": "HoudiniMutation",
    "hash": "5142f696ccaacdb44816806dc01ad6161ab0dbbc9b43520ca4236d0942832878",

    "raw": `mutation UpdateGroup($input: GroupUpdate!) {
  updateGroup(input: $input) {
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateGroup": {
                "type": "Group",
                "keyRaw": "updateGroup(input: $input)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "GroupUpdate"
        },

        "types": {
            "GroupPermissionInput": {
                "level": "PermissionLevel",
                "permissionId": "Int"
            },

            "GroupPermissionListUpdate": {
                "additions": "GroupPermissionInput",
                "removals": "Int"
            },

            "ListUpdate": {
                "additions": "Int",
                "removals": "Int"
            },

            "GroupUpdate": {
                "id": "Int",
                "name": "String",
                "permissions": "GroupPermissionListUpdate",
                "users": "ListUpdate"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=8c5d1f0dbcc1ea9396c8c361cb1edeb934ed2c037c8b3f377969e1c80537b21e";